
import descriptionMarket from '../description/descriptionDefault';
export default{
    category:[
        {
            id : 1,
            food : false,
            display : true,
            title : descriptionMarket.srPath('stoke'),
            title_en : descriptionMarket.enPath('Livestock'),
            title_path : descriptionMarket.srPath('stoke'),
            title_path_en : descriptionMarket.enPath('livestock'),
            text: `
            <p>Cena stoke na stočnoj pijaci u Srbiji zavisi od trenutne ponude i potražnje stoke na tržištu. Stoku otkupljuju klanice na veću količinu grla, potom je zastupljena pojedinačna prodaja stoke</p></br>
            <p>Cena varira od stočne pijace do pijace, rase, starosti stoke, kraja u Srbiji (cena stoke u Vojvodini se razlikuje od cene stoke u centralnoj ili zapadnoj Srbiji), grada do grada i od ponude tokom godine</p></br>
            <p>U Srbiji se stoka uzgaja i tovi za dobijanje mesa, proširenje i razvoj postojećeg fonda i dalju prodaju stoke. Stoka se prodaje po kilogramu težine, ali i po količini ukoliko se prodaje više od jednog grla. </p></br>
            `,
            color: 'secondary',
            class: 'm-0 p-0 ',
            stips_category : 3,
            stips_subcategory : 3,
            img : 'livestock.webp',
            ads_category:['Stoka','Živina','Mašine i oprema','Lov i ribolov'],
            ads_single: 'Stoka'


       }, 
       {
        id : 2,
        food : false,
        display : true,
        title : descriptionMarket.srPath('voća'),
        title_en : descriptionMarket.enPath('Fruit'),
        title_path : descriptionMarket.srPath('voca'),
        title_path_en : descriptionMarket.enPath('fruit'), 
        text: `
        <p>Cena voća na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje voća na svetskoj berzi, da li je cena na veliko, da li je voće za jelo, rakiju, sokove, pekmeze, kompote, slatko.</p></br>
        <p>Cena varira od pijace do pijace, koje je voće, kraja u Srbiji (cena voća u Vojvodini se razlikuje od cene voća u istočnoj ili zapadnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</p></br>
        <p>U Srbiji se voće sadi i gaji i obrađuje za jelo, pravljenje sokova, marmelada, džemova, pekmeza, slatkog, sirupa, pečenje rakije. Voće se prodaje i otkupljuje uglavnom po kilogramu težine.</p></br>
        `,
        color: 'danger',
        class: 'm-0 p-0 ',
        stips_category : 1,
        stips_subcategory : 1,
        img : 'fruits.webp',
        ads_category:['Voće','Zemljište i usluge'],
        ads_single: 'Voće'

    },
        {
            id : 3,
            display : true,
            food : false,
            title : descriptionMarket.srPath('žitarica'),
            title_en : descriptionMarket.enPath('Cereals'),
            title_path : descriptionMarket.srPath('zitarica'),
            title_path_en : descriptionMarket.enPath('cereals'),
            text: `
            <p>Cena žitarica na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje žitarica na svetskoj berzi.</p></br>
            <p>Cena varira od pijace do pijace, kraja u Srbiji (cena žitarica u Vojvodini se razlikuje od cene žitarica u istočnoj ili zapadnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine</p></br>
            <p>U Srbiji se žitarice gaje i obrađuju na nekoliko miliona hektara zemlje. Upotrebljavaju se isključivo za ishranu domaćih životinja, prerađivačku industriju, ali i za ljudsku ishranu, kao i za seme za sledeću godinu.</p></br>
            `,
            color: 'info',
            class: 'm-0 p-0 ',
            stips_category : 4,
            stips_subcategory : 4,
            img : 'cereals.webp',
            ads_category:['Žitarice','Semena i sadnice'],
            ads_single: 'Žitarice'
        },
        
       
       {
            id : 4,
            food : false,
            display : true,
            title : descriptionMarket.srPath('južnog voća'),
            title_en : descriptionMarket.enPath('Southern fruit'),
            title_path : descriptionMarket.srPath('juznog voca'),
            title_path_en : descriptionMarket.enPath('southern fruit'),
            text: `
            <p>Cena južnog voća na pijaci zavisi od rodne godine zemlje odakle se uvozi, ponude i potražnje južnog voća na tržištu i berzama. Prodaja južnog voća je na malo po kilogramu težine</p></br>
            <p>Cena južnog voća varira od pijace do pijace, kraja u Srbiji (cena južnog voća u Vojvodini se razlikuje od cene južnog voća u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</p></br>
            <p>U Srbiji se južno voće uvozi za ljudsku upotrebu, sveže južno voće se jede ili u većini slučajeva konzumira se kao sok. Takođe južno voće se koristi i u proizvodnji keksa, bombona, ostaloj konditorskoj industriji, raznih torti, kolača</p></br>
            `,
            color: 'info',
            class: 'm-0 p-0 ',
            stips_category : 1,
            stips_subcategory : 4,
            img : 'southern.webp',
            ads_category:['Južno voće'],
            ads_single: 'Voće'


       },
       {
             id : 5,
            food : false,
            display : true,
            title : descriptionMarket.srPath('jaja i mleka'),
            title_en : descriptionMarket.enPath('Eggs and milk'),
            title_path : descriptionMarket.srPath('jaja i mleka'),
            title_path_en : descriptionMarket.enPath('eggs and milk'),
            text: `
            <p>Cena jaja na pijaci zavisi od ponude i potražnje jaja na tržištu i berzama. Prodaja jaja je po veličini jajeta i komadu.</br></br></p>\n\n                    <p>Cena jaja varira od pijace do pijace, kraja u Srbiji (cena jaja u Vojvodini se razlikuje od cene jaja u istočnoj ili zapadnoj Srbiji), grada do grada tokom godine.</br></br></p>\n                    \n                    <p>U Srbiji se jaja koriste za ljudsku upotrebu, pečena, kuvana, prilog jelima, pite, peciva. Takođe jaja se koriste i u proizvodnji keksa, bombona, ostaloj konditorskoj industriji, raznih torti, kolača.</br></br></p>                  
            `,
            color: 'success',
            class: 'm-0 p-0 ',
            stips_category : 12,
            stips_subcategory : 12,
            img : 'milk.webp',
            ads_category:['Mleko','Hrana'],
            ads_single: 'Voće'

       },
       {
            id : 6,
            food : false,
            display : true,
            title : descriptionMarket.srPath('povrća'),
            title_en : descriptionMarket.enPath('Vegetables'),
            title_path : descriptionMarket.srPath('povrca'),
            title_path_en : descriptionMarket.enPath('vegetables'),
            text: `
            <p>Cena povrća na pijaci u Srbiji zavisi od rodne godine, ponude i potražnje povrća na svetskoj berzi, da li je cena na veliko, da li je voće za jelo, zimnicu, sokove, industrijku obradu, hrana za stoku</p></br>
            <p>Cena varira od pijace do pijace, koje je povrće, kraja u Srbiji (cena povrća u Vojvodini se razlikuje od cene povrća u istočnoj ili zapadnoj ili južnoj Srbiji), grada do grada i od vremena (temperatura, kiša, mraz, suša) tokom godine.</p></br>
            <p>U Srbiji se povrće sadi i gaji i obrađuje za jelo, zimnicu, industrijsku obradu, hranu za stoku. Povrće se prodaje i otkupljuje uglavnom po kilogramu težine.</p></br>
            `,
            color: 'primary',
            class: 'm-0 p-0 ',
            stips_category : 2,
            stips_subcategory : 2,
            img : 'vegetables.webp',
            ads_category:['Povrće','Pčelarstvo','Ostalo'],
            ads_single: 'Povrće'
       },
       {
        id : 7,
        food : true,
        display : false,
        title : 'Stočna hrana',
        title_path : 'Stocna hrana',
        title_en : 'fodder serbia',
        title_path_en : 'fodder serbia',
        text: `
        <p>Cena hrane za stoku ili stočne hrane zavisi od ponude i potražnje kukuruza, pšenice, ječma, ostalih žitarica na tržištu.</p></br>
        <p>Hrana za stoku se vrednuje i ocenjuje na osnovu smeše, koliko ima ugljenih hidrata, koliko masti, koliko proteina, minerala, vitamina.</p></br>
        <p>
        U Srbiji se može kupiti smeše hrane za stoku od nekoliko kvalitetnih proizvođača stočne hrane ili od fabrika stočne hrane</p></br>
        `,
        color: 'primary',
        class: 'm-0 p-0 ',
        stips_category : 2,
        stips_subcategory : 2,
        img : 'livestockfood.webp',
        ads_category:['Stočna hrana'],
        ads_single: 'Stoka'

       },
       
    ]
}
